iScreenWizard.controller('EmaillogController', function ($scope, $state, $mdDialog, Ajax, Dictionary, Emaillog, userService) {

    var pageSize = 15;

    $scope.emaillogs = [];
    $scope.user = userService.model;
    $scope.searchTerm = '';
    $scope.page = 1;
    $scope.morePages = true;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.loadEmaillog();
    });

    $scope.loadEmaillog = function() {
        params = {
            pagesize: pageSize,
            page: $scope.page,
            orderby: 'aanmaakdatum',
            orderdesc: 1
        };
        if ($scope.searchTerm.length > 0) {
            params.searchterm = $scope.searchTerm;
        }
        Emaillog.all(params).then(function (emaillogs) {
            angular.forEach(emaillogs, function(emaillog) {
                $scope.emaillogs.push(emaillog);
            });
            $scope.page =  $scope.page+1;
            if (emaillogs.length < pageSize) {
                $scope.morePages = false;
            }
        });
    };

    $scope.searchEmailLog = function() {
        $scope.emaillogs = [];
        $scope.morePages = true;
        $scope.page = 1;
        $scope.loadEmaillog();
    };

    $scope.viewEmaillog = function(emaillogId,ev) {
        Emaillog.get(emaillogId).then(function (emaillog) {

            $mdDialog.show({
                controller: EmaillogDialogController,
                locals: {
                    emaillog: emaillog
                },
                templateUrl: '/mijn-iscreen/emaillogs/show',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true
            })
        });
    };

    function EmaillogDialogController($scope, emaillog) {
        $scope.emaillog = emaillog;
    };


});